<template>
    <div class="vue-go2Top">
        <transition name="fadeIn">
            <v-touch class="goTopButton" v-on:tap="go2Top" v-show="showGoTop"></v-touch>
        </transition>
    </div>
</template>

<script>
    export default {
        name: 'vue-go2Top',
        props: {
            propShow: {
                required: false,
                type: Boolean,
                default: null,
            },
            propOffset: {
                required: false,
                type: [Number, String],
                default: () => {
                    return document.body.offsetHeight
                }
            }
        },
        data() {
            return {
                showGoTop: false,
            };
        },
        mounted() {
            if(this.propShow == null ) {
                this.init();
            }
        },
        watch: {
            'propShow': function(newVal) {
                this.showGoTop = !!newVal;
            }
        },
        methods: {
            init() {
                const that = this;
//                使用prop的默认值取代这个值
//                const screenHeight = document.body.offsetHeight;
                let buffer = 0;
                document.addEventListener('scroll', function () {
                    const scrollTop = document.body.scrollTop;
                    if (buffer < 10) {
                        buffer++;
                    }
                    if (scrollTop > that.propOffset) {
                        that.$data.showGoTop = true;
                    } else {
                        that.$data.showGoTop = false;
                    }
                })
            },
            go2Top() {
                document.body.scrollTop = 0;
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../scss/function';

    .vue-go2Top {
        .goTopButton {
            position: fixed;
            z-index: 6;
            bottom: topx(157rem);
            right: topx(41rem);
            width: topx(84rem);
            height: topx(84rem);
            border-radius: 50%;
            border: topx(1rem) solid #F0F0F0;
            box-shadow: 1px -1px 4px 0 rgba(0, 0, 0, 0.27);
            background: #FDFDFD url('../../assets/icon/icon_up.svg') no-repeat center;
            background-size: topx(30rem);
            transform: rotate(135deg);
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/common/gotoTop.vue